import { Component, Input } from '@angular/core';
import { TYPES } from 'app/core/models/types.model';
import { Field } from '../models/field.model';

/**
 * Componente que construye los formularios dependiendo del campo
 */
@Component({
    selector: 'app-field-builder',
    template: `
    <div class="form-group row" [formGroup]="form">
      <div class="col-md-12" [ngSwitch]="field.type">
      <label class="form-control-label" [ngStyle]="{'color': color}" *ngIf="field.type !== TYPES.checkbox" >
        {{ field.label }}
        <strong class="text-danger" *ngIf="field.required">*</strong>
      </label>
        <app-date *ngSwitchCase="TYPES.date" [field]="field" [form]="form"></app-date>
        <app-textbox *ngSwitchCase="TYPES.text" [field]="field" [form]="form"></app-textbox>
        <app-color *ngSwitchCase="TYPES.color" [field]="field" [form]="form"></app-color>
        <app-textbox *ngSwitchCase="TYPES.number" [field]="field" [form]="form"></app-textbox>
        <app-textarea *ngSwitchCase="TYPES.textarea" [field]="field" [form]="form"></app-textarea>
        <app-file-input *ngSwitchCase="TYPES.file_input" [field]="field" [form]="form"></app-file-input>
        <app-star-rating *ngSwitchCase="TYPES.rating" [field]="field" [form]="form"></app-star-rating>
        <app-dropdown
          *ngSwitchCase="TYPES.dropdown"
          [field]="field"
          [form]="form"
        ></app-dropdown>
        <app-checkbox
          *ngSwitchCase="TYPES.checkbox"
          [field]="field"
          [form]="form"
        ></app-checkbox>
        <app-file *ngSwitchCase="TYPES.file" [field]="field" [form]="form"></app-file>
        <div
          class="alert alert-secondary my-1 p-2 animated fadeInDown"
          role="alert"
          *ngIf="!isValid ? isTouched || isDirty : false">
          <div *ngIf="form.controls[field.name].errors.required"><strong class="text-danger">! Este valor es requerido.</strong></div>
          <div *ngIf="form.controls[field.name].errors.max">
            <strong class="text-danger">! El valor no puede ser mayor que {{ field.max }}.</strong></div>
          <div *ngIf="form.controls[field.name].errors.min">
            <strong class="text-danger">! El valor no puede ser menor que {{ field.min }}.</strong></div>
            <div *ngIf="form.controls[field.name].errors.minlength">
            <strong class="text-danger">! El valor no puede tener menos de {{ field.minLength }} carácteres.</strong></div>
          <div *ngIf="form.controls[field.name].errors.maxlength">
            <strong class="text-danger">! El valor no puede tener más de {{ field.maxLength }} carácteres.</strong></div>
          <div *ngIf="form.controls[field.name].errors.pattern">
            <strong class="text-danger">! El valor ingresado no es válido.</strong></div>
        </div>
      </div>
    </div>
  `,
    standalone: false
})
export class FieldBuilderComponent {
  /**
   * Campo del formulario
   */
  @Input() field!: Field;
  /**
   * Formulario
   */
  @Input() form: any;
  /**
   * Color de los labels
   */
  @Input() color = '#040403';
  /**
   * Tipos de campos
   */
  readonly TYPES = TYPES;

  /**
   * Indica si es valido o no
   */
  get isValid(): any {
    return this.form.controls[this.field.name].valid;
  }
  /**
   * Indica si esta sucio el campo
   */
  get isDirty(): any {
    return this.form.controls[this.field.name].dirty;
  }
  /**
   * Indica si se ha tocado el campo
   */
  get isTouched(): any {
    return this.form.controls[this.field.name].touched;
  }


  constructor() { }

}
